import * as React from "react";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import ButtonBase from "@mui/material/ButtonBase";
import wheat from "../assets/images/letter.png";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import TranslatedText from "./TranslatedText";

const Img = styled("img")({
  margin: "auto",
  display: "block",
  maxWidth: "100%",
  maxHeight: "100%",
});

const images = [
  "https://cdn.pixabay.com/photo/2022/03/07/14/11/wheat-7053755_640.png",
  "https://cdn.pixabay.com/photo/2020/08/06/17/51/woman-5468716_640.jpg",
  "https://cdn.pixabay.com/photo/2022/05/01/14/43/ukrainian-women-7167696_640.jpg",
  "https://cdn.pixabay.com/photo/2020/07/14/14/19/ukraine-5404369_640.jpg",
  "https://cdn.pixabay.com/photo/2022/03/14/11/29/ukraine-7067981_640.jpg",
  "https://cdn.pixabay.com/photo/2022/03/25/18/21/sheet-music-7091560_640.jpg",
  "https://cdn.pixabay.com/photo/2020/08/03/09/36/flag-5459623_640.jpg",
  "https://cdn.pixabay.com/photo/2022/04/11/10/37/sunflower-7125477_640.jpg",
  "https://cdn.pixabay.com/photo/2022/03/26/09/54/ukrainian-hryvnia-7092627_640.jpg",
  "https://cdn.pixabay.com/photo/2017/09/26/13/39/nice-2788652_640.jpg",
  "https://cdn.pixabay.com/photo/2019/10/14/22/58/ukraine-4550155_640.jpg",
  "https://cdn.pixabay.com/photo/2022/03/04/18/01/ukraine-7047830_640.jpg",
  "https://cdn.pixabay.com/photo/2017/06/30/11/38/fortress-2458087_640.jpg",
  "https://cdn.pixabay.com/photo/2015/09/26/22/27/ukraine-959905_640.jpg",
  "https://cdn.pixabay.com/photo/2022/03/05/10/54/flag-7048909_640.jpg",
  "https://cdn.pixabay.com/photo/2020/07/27/06/13/hand-5441435_1280.jpg",
  "https://cdn.pixabay.com/photo/2019/03/07/20/01/river-4040954_640.jpg",
];

function EventCard({ event }) {
  // const { name, startDate, endDate } = event;
  const name = event[1];
  const startDate = new Date(event[2]).toLocaleDateString();
  const endDate = new Date(event[3]).toLocaleDateString();
  const startTime = new Intl.DateTimeFormat("nb-NO", {
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(event[2]));
  const endTime = new Intl.DateTimeFormat("nb-NO", {
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(event[3]));
  const description = event[5];
  const age = event[10];
  const category = event[7];
  const address = event[8];
  // const randomImage = images[Math.floor(Math.random() * images.length)];

  let copyImages = [...images];

  function getRandomImage() {
    if (copyImages.length === 0) {
      copyImages = [...images]; // reset array when all images have been used
    }
    const index = Math.floor(Math.random() * copyImages.length);
    const selectedImage = copyImages[index];
    copyImages.splice(index, 1); // remove selected image from array
    return selectedImage;
  }

  return (
    <div className="" sx={{}}>
      <span style={{ color: "#2875b0", fontSize: "25px" }}>{startDate}</span>

      <Paper
        sx={{
          p: 2,
          margin: "auto",
          flexGrow: 1,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: "75vw",
          marginBottom: "5vh",
          borderStyle: "double",
          borderColor: "#d5d5d5",
          backgroundColor: (theme) =>
            theme.palette.mode === "dark" ? "#1A2027" : "white",
          "@media screen and (max-width: 1024px)": {
            width: "94vw",
            flexDirection: "column",
          },
          "@media screen and (max-width: 690px)": {
            flexDirection: "column",
            width: "90vw",
            backgroundColor: "#eee",
          },
        }}
      >
        <ButtonBase
          sx={{
            width: "20vw",
            height: "100%",
            padding: "3vh",
            "@media screen and (max-width: 1024px)": {
              width: "85vw",
            },

            "@media screen and (max-width: 690px)": {
              width: "80vw",
              display: "flex",
              flexDirection: "column",
            },
          }}
        >
          <Img alt="placeholder" src={getRandomImage()} />
        </ButtonBase>
        <Grid
          item
          xs={12}
          sm
          container
          sx={{
            width: "100vw",
            padding: 2,

            "@media screen and (max-width: 690px)": {
              width: "90vw",
              display: "flex",
              flexDirection: "column",
            },
          }}
        >
          <Grid
            item
            xs
            container
            direction="column"
            spacing={2}
            sx={{ "@media screen and (max-width: 690px)": { width: "90vw" } }}
          >
            <Grid
              item
              xs
              container
              direction="row"
              justifyContent="space-between"
              sx={{
                "@media screen and (max-width: 690px)": {},
              }}
            >
              <Grid item xs={8}>
                <Typography
                  variant="h6"
                  component="div"
                  sx={{
                    color: "#555656",
                    fontFamily: "sans-serif",
                    fontSize: "22px",
                    fontWeight: "400",
                    "@media screen and (max-width: 690px)": {
                      width: "30vw",
                      fontSize: "18px",
                      color: "#2875b0",
                    },
                  }}
                  gutterBottom
                >
                  <TranslatedText defaultText={name} />
                </Typography>
                <hr
                  className="calendar-hr"
                  sx={{
                    border: "none",
                    borderTop: "1px solid #ccc",
                    margin: "20px 0",
                  }}
                ></hr>
              </Grid>

              <Grid
                item
                xs={3}
                sx={{
                  backgroundColor: "#2875b0",
                  borderRadius: "5px",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  "@media screen and (max-width: 690px)": {
                    paddingRight: "14vw",
                    color: "black",
                  },
                }}
              >
                <AccessTimeIcon
                  sx={{
                    width: "30px",
                    height: "40px",
                    "@media screen and (max-width: 690px)": {
                      width: "12vw",
                      color: "black",
                    },
                  }}
                />
                <Typography
                  variant="h5"
                  sx={{
                    color: "white",
                    fontSize: "18px",
                    paddingLeft: 1,
                    "@media screen and (max-width: 690px)": {
                      color: "black",
                      fontSize: "16px",
                    },
                  }}
                  gutterBottom
                >
                  {startTime} - {endTime}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Typography
            variant="body1"
            sx={{
              padding: "4%",
              textAlign: "left",
              "@media screen and (max-width: 690px)": {
                weight: "100vw",
                fontSize: "16px",
                fontWeight: "100",
              },
            }}
            gutterBottom
          >
            <TranslatedText defaultText={description} />
          </Typography>

          <Grid
            item
            xs
            container
            direction="row"
            justifyContent="space-between"
            sx={{
              "@media screen and (max-width: 690px)": {
                flexDirection: "column",
              },
            }}
          >
            <Grid item xs={3}>
              <Typography variant="body2" gutterBottom>
                <strong>
                  <TranslatedText defaultText="Вік:" />
                </strong>{" "}
                <TranslatedText defaultText={age} />
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2" gutterBottom>
                <strong>
                  <TranslatedText defaultText="Категорія:" />
                </strong>{" "}
                <TranslatedText defaultText={category} />
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="body2" gutterBottom>
                <strong>
                  <TranslatedText defaultText="Адреса:" />
                </strong>{" "}
                <TranslatedText defaultText={address} />
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
}

export default function ComplexGrid({ events }) {
  return (
    <div className="calendar-paper">
      {events.map((event) => (
        <EventCard key={event[0]} event={event} />
      ))}
    </div>
  );
}
